import { useAsync } from 'react-use';
import { useAdminApi } from './useAdminApi';

// `id` is optional so a caller with an unusable route param can skip the request
// entirely: hooks run unconditionally, so a guard at the call site cannot stop it
export function useOrganizationById(id?: number) {
  const { apiClient } = useAdminApi();

  const state = useAsync(async () => {
    if (id === undefined) return undefined;
    const organization = await apiClient?.getOrganization(id);
    return organization;
  }, [apiClient, id]);

  return {
    organization: state.value,
    // useAdminApi resolves asynchronously, so useAsync reports loading:false for the
    // renders before apiClient exists
    loading: state.loading || !apiClient,
    error: state.error,
  };
}
